import React, { useState } from "react";
import "./DettyDecember.css";
import adImage from "../assets/detty-december.jpeg";
import { Helmet } from "react-helmet";
import stripeIcon from "../assets/stripe-icon.png";
import stripeLogo from "../assets/stripe-logo.png";

// Checkout session URLs from Stripe Dashboard
const ADULT_CHECKOUT_URL = "https://buy.stripe.com/9B63cx2UlfA9gTUfbkfYY02";
const CHILD_CHECKOUT_URL = "https://buy.stripe.com/bJeeVfeD32NnfPQ5AKfYY03";

export default function DettyDecember() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    numberOfAdults: 1,
    numberOfChildren: 0,
    days: [],
  });

  const [submitted, setSubmitted] = useState(false);
  const daysOptions = ["24th", "25th", "26th"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (day) => {
    setFormData((prev) => {
      const days = prev.days.includes(day)
        ? prev.days.filter((d) => d !== day)
        : [...prev.days, day];
      return { ...prev, days };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.email) {
      alert("Please fill in all required fields.");
      return;
    }

    if (formData.days.length === 0) {
      alert("Please select at least one day.");
      return;
    }

    if (formData.numberOfAdults < 1) {
      alert("At least one adult is required.");
      return;
    }

    try {
      const response = await fetch("/php/book-detty-december.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setSubmitted(true);
      } else {
        alert(result.error || "Something went wrong!");
      }
    } catch (err) {
      console.error(err);
      alert("Could not submit booking. Please try again later.");
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      numberOfAdults: 1,
      numberOfChildren: 0,
      days: [],
    });
  };

  // Redirect to Stripe in a new tab
  const redirectToStripe = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="page-container">
      <Helmet>
        <title>Detty December 2025 Booking | LasGidi Restaurant</title>
        <meta
          name="description"
          content="Book your spot for Detty December 2025 at LasGidi Restaurant. Reserve your table, select your preferred days, and enjoy an unforgettable festive experience in Manchester."
        />
        <meta
          name="keywords"
          content="Detty December, LasGidi Restaurant, Nigerian Food, Manchester Events, Festive Booking, Table Reservation"
        />
        <meta
          property="og:title"
          content="Detty December 2025 Booking | LasGidi Restaurant"
        />
        <meta
          property="og:description"
          content="Book your spot for Detty December 2025 at LasGidi Restaurant. Reserve your table, select your preferred days, and enjoy an unforgettable festive experience in Manchester."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="detty-container booking-container heading-container">
        <h1>Detty December 2025</h1>
      </div>

      {submitted ? (
        <div className="thank-you">
          <h2>Thank you for booking!</h2>
          <p>We have received your Detty December booking. 🎉</p>
          <p>Hope to see you there!</p>
          <button
            className="submit-button post-review-btn"
            onClick={() => {
              resetForm();
              setSubmitted(false);
            }}
          >
            Back to Form
          </button>
        </div>
      ) : (
        <div className="detty-main">
          <div className="detty-form-container">
            <h2>Book Your Spot Now!</h2>
            <form className="detty-form" onSubmit={handleSubmit}>
              {/* Name */}
              <div className="form-group">
                <label>
                  Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group flex-row">
                <div>
                  <label>
                    Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label>
                    Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Adults */}
              {/* Adults and Children on the same line */}
              <div className="form-group flex-row">
                <div>
                  <label>
                    Number of Adults <span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    name="numberOfAdults"
                    min="1"
                    value={formData.numberOfAdults}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label>Number of Children</label>
                  <input
                    type="number"
                    name="numberOfChildren"
                    min="0"
                    value={formData.numberOfChildren}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Days */}
              <div className="form-group">
                <label>
                  Days you will be attending <span className="required">*</span>
                </label>
                <div className="checkbox-group">
                  {daysOptions.map((day) => (
                    <label key={day}>
                      <input
                        type="checkbox"
                        checked={formData.days.includes(day)}
                        onChange={() => handleCheckboxChange(day)}
                      />
                      {day}
                    </label>
                  ))}
                </div>
              </div>

              <button type="submit" className="post-review-btn">
                Book Now
              </button>
            </form>

            {/* Custom Stripe Buttons */}
            <div className="stripe-trust-badge">
              <span>Pay directly with</span>
              <img src={stripeLogo} alt="Stripe" className="stripe-logo" />
            </div>

            <div className="stripe-buttons">
              <button
                className="custom-stripe-button adult-button"
                onClick={() => redirectToStripe(ADULT_CHECKOUT_URL)}
              >
                <img
                  src={stripeIcon}
                  alt="Stripe Icon"
                  className="stripe-button-icon"
                />
                Pay for Adults
              </button>

              <button
                className="custom-stripe-button child-button"
                onClick={() => redirectToStripe(CHILD_CHECKOUT_URL)}
              >
                <img
                  src={stripeIcon}
                  alt="Stripe Icon"
                  className="stripe-button-icon"
                />
                Pay for Children
              </button>
            </div>
          </div>

          <div className="detty-ad">
            <img src={adImage} alt="Detty December Promo" />
          </div>
        </div>
      )}
    </div>
  );
}
